.palette {
  width: 100%;
  overflow: hidden;
  border: 1px solid var(--arc-border);
  border-radius: var(--arc-radius-panel);
  background: var(--arc-surface);
  box-shadow: var(--arc-shadow-floating);
  transform-origin: top center;
}

.searchRow {
  position: relative;
  display: flex;
  min-height: 54px;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  border-bottom: 1px solid var(--arc-border-subtle);
  transition: background var(--arc-duration-fast) var(--arc-ease-standard);
}

.searchRow:focus-within { background: var(--arc-surface-muted); }
.searchIcon, .itemIcon { display: grid; flex: none; place-items: center; color: var(--arc-text-muted); }
.searchIcon { width: 22px; height: 22px; }
.searchRow input { min-width: 0; flex: 1; border: 0; outline: 0; background: transparent; color: var(--arc-foreground); font: inherit; font-size: var(--arc-text-sm); }
.searchRow input::placeholder { color: var(--arc-text-muted); }
.searchRow input:focus-visible { outline: none; }

.commandKey, .shortcut {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: none;
  border: 1px solid var(--arc-border);
  border-radius: 7px;
  background: var(--arc-surface-muted);
  color: var(--arc-text-muted);
  font-family: inherit;
  font-size: var(--arc-text-xs);
  font-weight: 500;
  line-height: 1;
  font-variant-numeric: tabular-nums;
}

.commandKey { min-width: 38px; height: 24px; padding: 0 6px; gap: 2px; }
.clearButton { display: grid; width: 24px; height: 24px; flex: none; place-items: center; border: 0; border-radius: 7px; background: transparent; color: var(--arc-text-muted); cursor: pointer; transition: color var(--arc-duration-fast) var(--arc-ease-standard), background-color var(--arc-duration-fast) var(--arc-ease-standard); }
@media (hover: hover) and (pointer: fine) { .clearButton:hover, .closeButton:hover { background: var(--arc-surface); color: var(--arc-foreground); } }
.clearButton:active, .closeButton:active { background: var(--arc-surface); color: var(--arc-foreground); }
.clearButton:focus-visible { outline: var(--arc-focus-width) solid var(--arc-accent); outline-offset: var(--arc-focus-offset); }
.closeButton { display: grid; min-width: 27px; height: 24px; flex: none; place-items: center; border: 1px solid var(--arc-border-subtle); border-radius: 7px; background: transparent; color: var(--arc-text-muted); padding: 0 6px; font: inherit; font-size: var(--arc-text-xs); font-weight: 500; line-height: 1; cursor: pointer; transition: color var(--arc-duration-fast) var(--arc-ease-standard), background-color var(--arc-duration-fast) var(--arc-ease-standard); }
.closeButton:focus-visible { outline: var(--arc-focus-width) solid var(--arc-accent); outline-offset: var(--arc-focus-offset); }

/* The frame animates to the list height; the list keeps its own scroll. */
.resultsFrame { overflow: hidden; }
.results { position: relative; max-height: 342px; overflow: auto; padding: 6px 8px; }
.highlight { position: absolute; top: 0; right: 8px; left: 8px; border-radius: 8px; background: var(--arc-surface-muted); opacity: 0; pointer-events: none; }
/* Groups are positioned so a row that pops out of the flow is placed against the same box it was measured in, even mid-glide. */
.group { position: relative; }
.group + .group { margin-top: 6px; }
.groupHeading { display: block; padding: 6px 8px 3px; color: var(--arc-text-muted); font-size: var(--arc-text-xs); font-weight: 500; line-height: var(--arc-leading-body); }

/* One line per result: the title, then its description in muted text, so the list stays short and scannable. */
.result { position: relative; display: flex; width: 100%; min-height: 34px; align-items: center; gap: 10px; border: 0; border-radius: 8px; padding: 0 8px; background: transparent; color: var(--arc-foreground); text-align: left; cursor: pointer; }
/* The active row is drawn by the shared highlight; the row itself only tints its icon and arrow. */
.itemIcon { transition: color var(--arc-duration-fast) var(--arc-ease-standard); }
.activeResult .itemIcon, .activeResult .result:focus-visible { outline: var(--arc-focus-width) solid var(--arc-accent); outline-offset: -2px; }
.itemIcon { display: grid; width: 16px; height: 16px; flex: none; place-items: center; color: var(--arc-text-muted); }
.itemIcon svg { width: 16px; height: 16px; }
.resultCopy { display: flex; min-width: 0; flex: 1; align-items: baseline; gap: 8px; }
.resultCopy strong, .resultCopy small { display: block; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.resultCopy strong { flex: none; max-width: 100%; }
.resultCopy small { min-width: 0; }
.resultCopy strong { font-size: var(--arc-text-sm); font-weight: 500; }
.resultCopy small { color: var(--arc-text-muted); font-size: var(--arc-text-xs); }
.shortcut { min-width: 18px; height: 18px; padding: 0 4px; border-color: transparent; border-radius: 5px; font-size: 11px; }
.activeResult 
.empty { display: grid; justify-items: center; gap: 4px; padding: 26px 12px 28px; text-align: center; }
.empty > span { display: grid; width: 32px; height: 32px; place-items: center; margin-bottom: 5px; color: var(--arc-text-muted); }
.empty strong { font-size: var(--arc-text-sm); font-weight: 500; }
.empty small { color: var(--arc-text-muted); font-size: var(--arc-text-xs); }
.visuallyHidden { position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0); white-space: nowrap; }

@media (max-width: 480px) {
  .searchRow { gap: 8px; padding: 8px 11px; }
  .results { padding: 6px; }
  .highlight { right: 6px; left: 6px; }
  .result { gap: 8px; }
  .shortcut, .commandKey { display: none; }
  }

@media (max-width: 340px) {
    .result { padding-inline: 6px; }
}

@media (prefers-reduced-motion: reduce) {
  .searchRow, .itemIcon, .clearButton, .closeButton { transition: none; }
}

:global([data-motion="reduced"]) .palette, :global([data-motion="reduced"]) .palette *, :global([data-motion="reduced"]) .frame, :global([data-motion="reduced"]) .frame * { transition: none; animation: none; }
